import React from 'react'
import { type ActionButtonProps } from '../../utility/types'

const ActionButton: React.FC<ActionButtonProps> = ({
  primaryLabel,
  secondaryLabel,
  primaryAction,
  secondaryAction,
  primaryLoading = false,
  secondaryLoading = false,
  primaryDisabled = false,
  secondaryDisabled = false,
  primaryButtonColor = 'bg-green-600 hover:bg-green-700 focus:ring-green-500',
  secondaryButtonColor = 'bg-white border-gray-300 text-gray-700 hover:bg-gray-50 focus:ring-gray-500'
}) => {
  return (
    <div className="px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse gap-3">
      <button
        type="button"
        className={`inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 text-base font-medium text-white focus:outline-none sm:ml-3 sm:w-auto sm:text-sm transition-colors duration-150 ${
          primaryButtonColor
        } ${
          primaryDisabled || primaryLoading ? 'opacity-70 cursor-not-allowed' : ''
        }`}
        onClick={primaryAction}
        disabled={primaryLoading || primaryDisabled}
      >
        {primaryLoading
          ? (
          <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mx-auto"></div>
            )
          : (
              primaryLabel
            )}
      </button>

      <button
        type="button"
        className={`inline-flex justify-center rounded-md border shadow-sm px-4 py-2 text-base font-medium focus:outline-none sm:mt-0 sm:w-auto sm:text-sm transition-colors duration-150 ${
          secondaryButtonColor.includes('bg-')
            ? secondaryButtonColor
            : `bg-white ${secondaryButtonColor}`
        } ${
          secondaryDisabled || secondaryLoading ? 'opacity-70 cursor-not-allowed' : ''
        }`}
        onClick={secondaryAction}
        disabled={secondaryLoading || secondaryDisabled}
      >
        {secondaryLoading
          ? (
          <div className={`animate-spin rounded-full h-5 w-5 border-b-2 ${
            secondaryButtonColor.includes('bg-red')
              ? 'border-white'
              : 'border-gray-600'
          } mx-auto`}></div>
            )
          : (
              secondaryLabel
            )}
      </button>
    </div>
  )
}

export default React.memo(ActionButton)
